var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"uk-display-inline"},[_c('div',{staticClass:"uk-display-inline",attrs:{"uk-spinner":'ratio: 1'}})])
}
var staticRenderFns = []

export { render, staticRenderFns }